const custLogCenter = {
    path: "custLogCenter",
    name: "custLogCenter",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'customerAuditLog',
        icon: 'HSIconfont hs-icon-file',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custLoginLog',
            name: 'custLoginLog',
            component: () => import('@/views/custLoginLog'),
            meta: { code: 'customerAuditLog:authLog' }
        },
        {
            path: 'custBusinessLog',
            name: 'custBusinessLog',
            component: () => import('@/views/custBusinessLog'),
            meta: { code: 'customerAuditLog:businessLog' }
        }
    ]
};
export default custLogCenter;
